<template>
  <v-card class="common-card_basket" :elevation="3">
    <v-col xl="5" lg="5" md="5" sm="7" xs="12">
      <div class="d-flex justify-center">
        <div class="img-empty">
          <img src="../../../../assets/images/emptycart.png" alt="empty" />
        </div>
      </div>

    </v-col>
    <v-col xl="5" lg="5" md="5" sm="7" xs="12">
      <div class="text-emptyCart">
        <h5>سبد خرید شما خالی است</h5>
        <h6>می‌توانید برای مشاهده محصولات به فروشگاه بروید</h6>
      </div>
    </v-col>
    <v-col xl="3" lg="3" md="4" sm="6" xs="10">
      <v-btn variant="flat" block class="btn_primary"  type="submit"
             @click="$router.push('/store/all')">
        فروشگاه
      </v-btn>
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: "EmptyCart"
}
</script>

<style scoped>

</style>
